// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2YvsE","title":"Header_title__1pzOi","side":"Header_side__1YJJs"};